import { render, staticRenderFns } from "./IntegracaoDialogLog.vue?vue&type=template&id=d8820772"
import script from "./IntegracaoDialogLog.vue?vue&type=script&lang=js"
export * from "./IntegracaoDialogLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports